import petrolImg from "../assets/petrol.png"

const defaultSections = [
  {
    label: "Advanced hardwarecomponents",
    image: petrolImg,
    imageAlt: "Fuel hardware component",
    imagePosition: "right",
    items: [
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
    ],
  },
  {
    label: "Advanced hardwarecomponents",
    image: petrolImg,
    imageAlt: "Fuel hardware component",
    imagePosition: "left",
    items: [
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
      "Live tank inventory with level, density, and temperature tracking",
    ],
  },
]

function ComponentPoints({ label, items = [] }) {
  return (
    <div className="w-full">
      <p className="text-xs font-medium text-black/70 sm:text-sm">{label}</p>

      <div className="mt-6 space-y-4 sm:space-y-5">
        {items.map((item, index) => (
          <div key={`${item}-${index}`} className="border-b border-[#cdb99f] pb-3">
            <div className="flex items-center gap-3 sm:gap-4">
              <span className="min-w-[34px] text-[26px] font-semibold leading-none text-transparent [-webkit-text-stroke:1px_#ed860f] sm:min-w-[42px] sm:text-[32px]">
                {String(index + 1).padStart(2, "0")}
              </span>

              <p className="text-xs font-semibold leading-relaxed text-black sm:text-sm">
                {item}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default function CoreComponents({
  title = "Core Components",
  desc = "Our solution integrates multiple advanced systems to provide comprehensive fleet supervision.",
  sections = defaultSections,
}) {
  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20">
      <div className="mx-auto w-full max-w-[1490px] px-5 sm:px-8 lg:px-12 xl:px-20">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
            {title}
          </h2>

          <p className="mx-auto mt-3 max-w-[820px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
            {desc}
          </p>
        </div>

        <div className="mt-12 space-y-10 lg:mt-14 lg:space-y-14">
          {sections.map((section, index) => {
            const imageBlock = (
              <div className="overflow-hidden rounded-xl">
                <img
                  src={section.image}
                  alt={section.imageAlt || section.label}
                  className="h-[260px] w-full object-cover sm:h-[330px] lg:h-[360px]"
                />
              </div>
            )

            const textBlock = (
              <ComponentPoints label={section.label} items={section.items} />
            )

            return (
              <div
                key={`${section.label}-${index}`}
                className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14"
              >
                {section.imagePosition === "left" ? (
                  <>
                    {imageBlock}
                    {textBlock}
                  </>
                ) : (
                  <>
                    {textBlock}
                    {imageBlock}
                  </>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
